import * as React from "../_snowpack/pkg/react.js";
import {Input, Spinner, Stack} from "../_snowpack/pkg/@apsphysics/tesseract-ui-core.js";
import {
  getAllAnnualData,
  getAllInstitutions,
  getAllNationalAverages,
  getInstitutionWithData
} from "./apiService.js";
import DataPresentation from "./components/DataPresentation.js";
import SelectDegreeType from "./components/SelectDegreeType.js";
import SourceInfo from "./components/SourceInfo.js";
import {getNationalCounts} from "./utils.js";
const App = () => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [shouldDisplayList, setShouldDisplayList] = React.useState(false);
  const [allInstitutions, setAllInsitutions] = React.useState([]);
  const [nationalAverages, setNationalAverages] = React.useState([]);
  const [nationalCounts, setNationalCounts] = React.useState(null);
  const [filteredInstitutions, setFilteredInstitutions] = React.useState([]);
  const [selectedInstitution, setSelectedInstitution] = React.useState(null);
  const [selectedDegreeType, setSelectedDegreeType] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(null);
  React.useEffect(() => {
    getAllInstitutions().then((institutions) => {
      institutions && setAllInsitutions(institutions);
    });
    getAllAnnualData().then((allData) => {
      allData && setNationalCounts(getNationalCounts(allData));
    });
    getAllNationalAverages().then((allAverages) => {
      allAverages && setNationalAverages(allAverages);
    });
  }, []);
  React.useEffect(() => {
    if (!allInstitutions.length)
      return;
    setFilteredInstitutions((_) => allInstitutions?.filter((i) => i.name.toLowerCase().match(searchTerm.toLowerCase())));
  }, [allInstitutions, searchTerm]);
  function selectInstitutionHandler(institution) {
    setIsLoading(institution.ficeCode);
    getInstitutionWithData(institution.ficeCode).then((institutionWData) => {
      setIsLoading(null);
      setSelectedInstitution(institutionWData);
      setSearchTerm(institution.name);
      setShouldDisplayList(false);
    });
  }
  const clearButton = selectedInstitution ? /* @__PURE__ */ React.createElement("button", {
    className: "px-4 py-2 my-2 hover:bg-gray-200 cursor-pointer text-left",
    onClick: () => {
      setSelectedInstitution(null);
      setSelectedDegreeType(null);
      setSearchTerm("");
    }
  }, "Clear selection") : /* @__PURE__ */ React.createElement(React.Fragment, null);
  const filteredStack = /* @__PURE__ */ React.createElement(Stack, {
    direction: "column",
    gap: 0,
    fullWidth: true
  }, filteredInstitutions.map((institution) => /* @__PURE__ */ React.createElement("button", {
    key: institution.ficeCode,
    className: "flex items-center px-4 py-2 text-left hover:bg-gray-200 cursor-pointer ",
    onClick: () => selectInstitutionHandler(institution)
  }, /* @__PURE__ */ React.createElement("span", {
    className: "pr-4"
  }, institution.name), isLoading === institution.ficeCode ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null))));
  return /* @__PURE__ */ React.createElement("section", {
    className: "m-4 p-4 flex flex-col border"
  }, /* @__PURE__ */ React.createElement("article", null, /* @__PURE__ */ React.createElement("h1", {
    className: "pr-4"
  }, "Find your institution:"), /* @__PURE__ */ React.createElement(Input, {
    value: searchTerm,
    onChange: (e) => setSearchTerm(e.target.value),
    onFocus: () => setShouldDisplayList(true),
    disabled: Boolean(selectedInstitution)
  }), shouldDisplayList ? filteredStack : /* @__PURE__ */ React.createElement(React.Fragment, null), clearButton, selectedInstitution ? /* @__PURE__ */ React.createElement(SelectDegreeType, {
    selectedInstitution,
    setDegree: setSelectedDegreeType,
    nationalCounts
  }) : /* @__PURE__ */ React.createElement(React.Fragment, null)), selectedDegreeType ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("article", null, /* @__PURE__ */ React.createElement(DataPresentation, {
    institution: selectedInstitution,
    degreeType: selectedDegreeType,
    nationalCounts,
    nationalAverages
  })), /* @__PURE__ */ React.createElement(SourceInfo, null)) : /* @__PURE__ */ React.createElement(React.Fragment, null));
};
export default App;
